import { categories } from '@/mocks/movies';

interface CategoryTabsProps {
  active: string;
  onChange: (slug: string) => void;
}

export default function CategoryTabs({ active, onChange }: CategoryTabsProps) {
  return (
    <div className="w-full overflow-x-auto scrollbar-hide">
      <div className="flex items-center gap-1 px-1 py-1 bg-background-100 rounded-full w-fit">
        {categories.map((cat) => (
          <button
            key={cat.slug}
            onClick={() => onChange(cat.slug)}
            className={`px-4 py-2 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer transition-all duration-200 ${
              active === cat.slug
                ? 'bg-primary-500 text-white shadow-sm'
                : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200/70'
            }`}
          >
            {cat.name}
          </button>
        ))}
      </div>
    </div>
  );
}